import { render } from "./Edits.vue?vue&type=template&id=4b210c07&scoped=true"
import script from "./Edits.vue?vue&type=script&lang=js"
export * from "./Edits.vue?vue&type=script&lang=js"

import "./Edits.vue?vue&type=style&index=0&id=4b210c07&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b210c07"]])

export default __exports__